import React from "react";
import { CreateNFeContext } from "../../../Context";
import { _Input } from "../../../../../../../_components/Input";
import { useSetFinNFe } from "./hooks";

const options = [
  {
    label: "1=NF-e normal",
    value: "1",
  },
  {
    label: "2=NF-e complementar",
    value: "2",
  },
  {
    label: "3=NF-e de ajuste",
    value: "3",
  },
  {
    label: "4=Devolução",
    value: "4",
  },
];

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const setFinNFe = useSetFinNFe()

  return (
    <div>
      <_Input
        onChange={setFinNFe}
        label="* Finalidade da NF-e"
        value={context.nfe.identification.fin_nfe}
        options={options}
        type="select"
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/FinNFe/index.jsx